// extracted by mini-css-extract-plugin
module.exports = {"container":"Game_container__3V4Qa","signupContainer":"Game_signupContainer__-cNxP","enterGameButton":"Game_enterGameButton__1up48"};